﻿export class VideoMatrix {
    /**
     * Full Width Carousel
     * Display an carousel that covers viewport
     * @param {Carousel} element 
     */
    constructor(element) {
        this._refs = {
            el: element,
            columns: Array.from(element.querySelectorAll('.video-matrix__column')),
            items: Array.from(element.querySelectorAll('.video-matrix__item'))
        }

        this._data = {
            currentItem: null
        };

        // # Events
        this._refs.items.forEach(x => {
            // Link
            const oLink = x.querySelector('.video-matrix__link[data-video-lightbox]');
            if (oLink != null) {
                oLink.addEventListener('click', this._onItemLinkClick.bind(this));
            }
        });

        document.addEventListener('hidden.bs.modal.video', this._onModalVideoClose.bind(this));

        if ("IntersectionObserver" in window) {
            // # Intersection
            const onIntersection = entries => {
                const oEntry = entries[0],
                    oVideoItem = this._refs.columns[0].querySelector('video');

                if (oEntry.intersectionRatio <= 0) {
                    if (oVideoItem != null) {
                        oVideoItem.pause();
                    }
                    oEntry.target.classList.remove('is-in-view');
                } else {
                    if (oVideoItem != null) {
                        oVideoItem.play();
                    }
                    oEntry.target.classList.add('is-in-view');
                }
            },
                oIntersectionObserver = new IntersectionObserver(onIntersection, {
                    threshold: 0.01
                });

            oIntersectionObserver.observe(this._refs.el);
        }
    }

    /**
     * Callback for when Lightbox executes event callback
     */
    _onModalVideoClose(e) {
        const el = e.detail.el.closest('.video-matrix__item');

        if (el != null) {
            const oItemVideo = el.querySelector('video');

            if (oItemVideo != null) {
                oItemVideo.play();
                this._data.currentItem = null;
            }
        }
    }

    /**
     * Handler for when user clicks on CTA
     * @param {Event} e - Event interface
     */
    _onItemLinkClick(e) {
        // Find mainElement
        const oItem = e.target.closest('.video-matrix__item'),
            oItemVideo = oItem.querySelector('video');

        // Video handling
        if (oItemVideo != null) {
            this._data.currentItem = oItem;
            oItemVideo.pause();
        }
    }
} 